import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
//import OurLegacy from "../OurLegacy/OurPolicy";
import { Container, Col, Row } from "react-bootstrap";
import Slider from "react-slick";
import EachTestiImg from "./../../../Images/testimonials.png";
import Testimonial5Img from "./../../../Images/Testimonial5.png";
import Testimonial6Img from "./../../../Images/Testimonial6.png";
import Testimonial8Img from "./../../../Images/Testimonial8.png";
import Testimonial1Img from "./../../../Images/Testimonial1.png";
import Testimonial2Img from "./../../../Images/Testimonial2.png";
import Testimonial3Img from "./../../../Images/Testimonial3.png";
import Testimonial4Img from "./../../../Images/Testimonial4.png";
import Testimonial7Img from "./../../../Images/Testimonial7.png";
import Testimonial9Img from "./../../../Images/Testimonial9.png";
import Testimonial10Img from "./../../../Images/Testimonial10.png";
import "./Quotes.css";
import {
  AiOutlineCloseCircle
} from "react-icons/ai";

function Quotes() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [show1, setShow1] = useState(false);
  const handleClose1 = () => setShow1(false);
  const handleShow1 = () => setShow1(true);

  const [show2, setShow2] = useState(false);
  const handleClose2 = () => setShow2(false);
  const handleShow2 = () => setShow2(true);

  const [show3, setShow3] = useState(false);
  const handleClose3 = () => setShow3(false);
  const handleShow3 = () => setShow3(true);

  const [show4, setShow4] = useState(false);
  const handleClose4 = () => setShow4(false);
  const handleShow4 = () => setShow4(true);

  const [show5, setShow5] = useState(false);
  const handleClose5 = () => setShow5(false);
  const handleShow5 = () => setShow5(true);

  const [show6, setShow6] = useState(false);
  const handleClose6 = () => setShow6(false);
  const handleShow6 = () => setShow6(true);

  const [show7, setShow7] = useState(false);
  const handleClose7 = () => setShow7(false);
  const handleShow7 = () => setShow7(true);

  const [show8, setShow8] = useState(false);
  const handleClose8 = () => setShow8(false);
  const handleShow8 = () => setShow8(true);

  const [show9, setShow9] = useState(false);
  const handleClose9 = () => setShow9(false);
  const handleShow9 = () => setShow9(true);
    
  const settings = {
    dots: false,
    autoplay: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <>
      <section className="quotes-section">
        <Container className="border-right">
          <Row>
            <Col md={{ span: "12", offset: "0" }}>
              {/* <h3>
                <span>Why customer trust us</span>
              </h3> */}
              <h3>
                <span>What Client Say About Us</span>
              </h3>
              <Slider className='testimonial-slider' {...settings}>
                <div className="testimonial_panel" onClick={handleShow}>
                  <img className="img-fluid" src={Testimonial5Img} alt="img1" />
                  <div className="testimonial_cont">
                  <h4>Manish Agarwal</h4>
                  {/* <h6>Director GA Solutions Private Limited, Kolkata</h6> */}
 
                  <h6>Director & CFO Crizac Ltd, Kolkata</h6>
                  <p>We have been associated with Mansukh for more than 15 years.  We use their website and Trading Applications for all types of investment needs such as equity trading, Derivatives-Equity /Commodity /Currency, Mutual funds. Perfectly aligned systems with speed and comfort. </p>
                </div>
                </div>
                <div  className="testimonial_panel" onClick={handleShow1}>
                  <img className="img-fluid" src={Testimonial6Img} alt="img1" />
                  <div className="testimonial_cont">
                  <h4>Ms.Sanya Jain</h4>
                  <h6>New Delhi</h6>
                  <p>You guys are really good. Best platform  for new investors. Love with Moneysukh Mobile app. I can place order myself with lots of information and specially appreciate their technical  charts functions</p>
                </div>
                </div>
                <div className="testimonial_panel" onClick={handleShow2}>
                  <img className="img-fluid" src={Testimonial8Img} alt="img1" />
                  <div className="testimonial_cont">
                  <h4>Rajat Aggarwal</h4>
                  <h6>Solan</h6>
                  <p>I learned about the equity and derivative markets while trading with MANSUKH. My experience with the company is memorable. I  like following their recommendations.</p>
                </div>
                </div>
                <div className="testimonial_panel" onClick={handleShow3}>
                  <img className="img-fluid" src={Testimonial1Img} alt="img1" />
                  <div className="testimonial_cont">
                  <h4>Amit Kumar Shorewala</h4>
                  <h6>New Delhi</h6>
                  <p>It’s always been a great experience with Mansukh. Trading with them for more than 15 years and never faced any challenges.</p>
                </div>
                </div>
                <div className="testimonial_panel" onClick={handleShow4}>
                <img className="img-fluid" src={Testimonial4Img} alt="img1" />
                  <div className="testimonial_cont">
                  <h4>Kanwal Nain Katyal</h4>
                  <h6>Karnal</h6>
                  <p>MANSUKH has got a great  customer service  team  which is very patient, cordial, prompt and professional in their responses.I've so far loved my long satisfying journey with them.Good Work Mansukh Team ! Keep Going !</p>
                </div>
                </div>
                <div className="testimonial_panel" onClick={handleShow5}>
                  <img className="img-fluid" src={Testimonial3Img} alt="img1" />
                  <div className="testimonial_cont">
                  <h4>Dr Tripta Gupta</h4>
                  <h6>New Delhi</h6>
                  <p>MANSUKH  has ensured Moneysukh for my Family since 1995 and this journey with them continues.</p>
                </div>
                </div>
                <div className="testimonial_panel" onClick={handleShow6}>
                <img className="img-fluid" src={Testimonial7Img} alt="img1" />
                  <div className="testimonial_cont">
                  <h4>Ms.Vidhi M.Shah</h4>
                  <h6>Mumbai</h6>
                  <p>Congratulate the whole Mansukh team for their consistent support. Highly satisfied with their Apps and feedback system. Keep continuing with your good work and new innovations.</p>
                </div>
                </div>
                <div className="testimonial_panel" onClick={handleShow7}>
                <img className="img-fluid" src={Testimonial2Img} alt="img1" />
                  <div className="testimonial_cont">
                  <h4>Dinesh Kumar Bagga</h4>
                  <h6>Director, Oasis Realtors Private Limited,New Delhi</h6>
                  <p>Indeed the most supportive and responsive staff I've ever worked with. Very professional and skilled. Best in class trading platform. Helped me a lot in building my portfolio with their precise research & round the clock support.</p>
                </div>
                </div>
                <div className="testimonial_panel" onClick={handleShow8}>
                  <img className="img-fluid" src={Testimonial9Img} alt="img1" />
                  <div className="testimonial_cont">
                  <h4>Sunil Singla</h4>
                  <h6>Chandigarh</h6>
                  <p>MANSUKH is an Investor friendly brokerage house. It has been a very satisfying journey with MANSUKH team and I really enjoyed my dealings with them. If you are one of those who likes to spend less time for any set up,  Mansukh is for you, it took me only 3 -4 minutes for account opening. </p>
                </div>
                </div>
                <div className="testimonial_panel" onClick={handleShow9}>
                  <img
                    className="img-fluid"
                    src={Testimonial10Img}
                    alt="img1"
                  />
                  <div className="testimonial_cont">
                  <h4>C.K.Ravindra</h4>
                  <h6>Bengaluru</h6>
                  <p>It has been a long journey with MANSUKH and I am more than satisfied with an Unmatched Class of research, support and software applications. Kudos to  MANSUKH !</p>
                </div>
                </div>
              </Slider>
              {/* <Modal show={show} onHide={handleClose} className="partner-modal">
                <Button variant="secondary" onClick={handleClose} className="btn-close text-right">
                  <AiOutlineCloseCircle />
                </Button>
                <Modal.Body>
                  <h4>Manish Agarwal</h4>
                  <h6>Director GA Solutions Private Limited, Kolkata</h6>
                  <p>We have been associated with Mansukh for more than 15 years.  We use their website and Trading Applications for all types of investment needs such as equity trading, Derivatives-Equity/Commodity/Currency, Mutual funds. Perfectly aligned systems with speed and comfort. </p>
                </Modal.Body>
              </Modal>
              <Modal show={show1} onHide={handleClose1} className="partner-modal">
                <Button variant="secondary" onClick={handleClose1} className="btn-close text-right">
                  <AiOutlineCloseCircle />
                </Button>
                <Modal.Body>
                  <h4>Ms.Sanya Jain</h4>
                  <h6>New Delhi</h6>
                  <p>You guys are really good. Best platform  for new investors. Love with Moneysukh Mobile app. I can place order myself with lots of information and specially appreciate their technical  charts functions</p></Modal.Body>
              </Modal>
              <Modal show={show2} onHide={handleClose2} className="partner-modal">
                <Button variant="secondary" onClick={handleClose2} className="btn-close text-right">
                  <AiOutlineCloseCircle />
                </Button>
                <Modal.Body>
                  <h4>Rajat Aggarwal</h4>
                  <h6>Solan</h6>
                  <p>I learned about the equity and derivative markets while trading with MANSUKH. My experience with the company is memorable. I  like following their recommendations.</p>
                </Modal.Body>
              </Modal>
              <Modal show={show3} onHide={handleClose3} className="partner-modal">
                <Button variant="secondary" onClick={handleClose3} className="btn-close text-right">
                  <AiOutlineCloseCircle />
                </Button>
                <Modal.Body>
                  <h4>Amit Kumar Shorewala</h4>
                  <h6>New Delhi</h6>
                  <p>It’s always been a great experience with Mansukh. Trading with them for more than 15 years and never faced any challenges.</p></Modal.Body>
              </Modal>
              <Modal show={show4} onHide={handleClose4} className="partner-modal">
                <Button variant="secondary" onClick={handleClose4} className="btn-close text-right">
                  <AiOutlineCloseCircle />
                </Button>
                <Modal.Body>
                  <h4>Dinesh Kumar Bagga</h4>
                  <h6>Director, Oasis Realtors Private Limited,New Delhi</h6>
                  <p>Indeed the most supportive and responsive staff I've ever worked with. Very professional and skilled. Best in class trading platform. Helped me a lot in building my portfolio with their precise research & round the clock support.</p></Modal.Body>
              </Modal>
              <Modal show={show5} onHide={handleClose5} className="partner-modal">
                <Button variant="secondary" onClick={handleClose5} className="btn-close text-right">
                  <AiOutlineCloseCircle />
                </Button>
                <Modal.Body>
                  <h4>Dr Tripta Gupta</h4>
                  <h6>New Delhi</h6>
                  <p>MANSUKH  has ensured Moneysukh for my Family since 1995 and this journey with them continues.</p></Modal.Body>
              </Modal>
              <Modal show={show6} onHide={handleClose6} className="partner-modal">
                <Button variant="secondary" onClick={handleClose6} className="btn-close text-right">
                  <AiOutlineCloseCircle />
                </Button>
                <Modal.Body>
                  <h4>Kanwal Nain Katyal</h4>
                  <h6>Karnal</h6>
                  <p>MANSUKH has got a great  customer service  team  which is very patient, cordial, prompt and professional in their responses.I've so far loved my long satisfying journey with them.Good Work Mansukh Team ! Keep Going !</p></Modal.Body>
              </Modal>
              <Modal show={show7} onHide={handleClose7} className="partner-modal">
                <Button variant="secondary" onClick={handleClose7} className="btn-close text-right">
                  <AiOutlineCloseCircle />
                </Button>
                <Modal.Body>
                  <h4>Ms.Vidhi M.Shah</h4>
                  <h6>Mumbai</h6>
                  <p>Congratulate the whole Mansukh team for their consistent support. Highly satisfied with their Apps and feedback system. Keep continuing with your good work and new innovations.</p></Modal.Body>
              </Modal>
              <Modal show={show8} onHide={handleClose8} className="partner-modal">
                <Button variant="secondary" onClick={handleClose8} className="btn-close text-right">
                  <AiOutlineCloseCircle />
                </Button>
                <Modal.Body>
                  <h4>Sunil Singla</h4>
                  <h6>Chandigarh</h6>
                  <p>MANSUKH is an Investor friendly brokerage house. It has been a very satisfying journey with MANSUKH team and I really enjoyed my dealings with them. If you are one of those who likes to spend less time for any set up,  Mansukh is for you, it took me only 3 -4 minutes for account opening. </p></Modal.Body>
              </Modal>
              <Modal show={show9} onHide={handleClose9} className="partner-modal">
                <Button variant="secondary" onClick={handleClose9} className="btn-close text-right">
                  <AiOutlineCloseCircle />
                </Button>
                <Modal.Body>
                  <h4>C.K.Ravindra</h4>
                  <h6>Bengaluru</h6>
                  <p>It has been a long journey with MANSUKH and I am more than satisfied with an Unmatched Class of research, support and software applications. Kudos to  MANSUKH !</p></Modal.Body>
              </Modal> */}
            </Col>
          </Row>
          <Row>
            <Col>{/* <OurLegacy /> */}</Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Quotes;
